import { writable } from "svelte/store";
export const initialState = {
    token: ''
};
function appStore() {
    const { subscribe, update } = writable(initialState);
    return {
        subscribe,
        setToken: (payload) => {
            update((state) => {
                const newState = Object.assign({}, state);
                newState.token = payload;
                state = newState;
                return newState;
            });
        },
    };
}
export const AppStore = appStore();
